/*
 * Copyright (c) 2022, WSO2 LLC (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { makeStyles, Theme } from "@material-ui/core/styles";
import { HTTP_METHODS, WS_METHODS } from '../../../data/constants';

export const useStyles = makeStyles((theme: Theme) => ({
  operation: {
    border: `1px solid ${theme.palette.grey[100]}`,
    cursor: 'default',
  },
  verb: {
    color: theme.palette.common.white
  },
}));

export const verbChipColors = {
  [HTTP_METHODS.GET]: "#0095FF",
  [HTTP_METHODS.POST]: "#05A26B",
  [HTTP_METHODS.PUT]: "#FF9D52",
  [HTTP_METHODS.DELETE]: "#F0503C",
  [HTTP_METHODS.OPTIONS]: "#2366CC",
  [HTTP_METHODS.PATCH]: "#745BCC",
  [HTTP_METHODS.HEAD]: "#58CABB",
  [WS_METHODS.PUBLISH]: "#0095FF",
  [WS_METHODS.SUBSCRIBE]: "#05A26B",
};
